export default "__VITE_ASSET__DDQC8Z$P__"